import { Css } from "@homebound/beam";
import { getStage } from "src/context";
import { LoginButton } from "./LoginButton";

export function SignIn() {
  const stage = getStage();
  const environmentName = stageNameMap[stage];

  return (
    <div css={Css.df.fdc.aic.jcc.mvh100.$}>
      <div css={Css.df.fdc.aic.jcsb.wPx(400).p4.br8.bshBasic.$}>
        <h1 css={Css.xl2.mb3.$}>InsideMaps Tool</h1>
        <div css={Css.mb3.$}>
          <LoginButton />
        </div>
        <div css={Css.df.w100.jcsb.xs.gray600.$}>
          {environmentName ? <span>{environmentName}</span> : <span />}
          <a href="mailto:product-support@homebound.com">
            <span css={Css.gray800.$}>Contact Product Ops</span>
          </a>
        </div>
      </div>
    </div>
  );
}

const stageNameMap: Record<string, string> = { local: "Localhost", dev: "Development", qa: "QA" };
